export default __webpack_public_path__ + "static/media/hydrate.37d8ea94.png";